import React from 'react'
import "./index.css"

const SectionTitle = ({ msg, children, subMsg , footerMsg}) => {
    return (
        <div className="checkout_section_title" >
            <div className='checkout_section_msg_box' >
                <h3>{msg}</h3>
                <p>{subMsg}</p>
            </div>
            {children}
            <div className='checkout_footer_msg' >
                {footerMsg}
            </div>
        </div>
    )
}

export default SectionTitle